module.exports = __webpack_public_path__ + "static/media/dropDownArrow.a97dbe33.svg";